export default __webpack_public_path__ + "static/media/clearNight.6e0eb4e5.svg";